import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReddyAuth } from './ReddyAuth';
import IconImg from './IconImg';
import { EVT } from '../../data/homeData';

/* Logged-in header nav: two expo_bal pills (Bal / Exp) + the nav-profile account
   dropdown (React-controlled, no Bootstrap JS; closes on outside-click). */
const MENU = [
  { label: 'home', img: true, href: '/' },
  { label: 'My Profile', icon: 'bi-person', href: '/profile' },
  { label: 'Account statement', icon: 'bi-bar-chart-steps', href: '/reports/account-statement' },
  { label: 'Bonus Rules', icon: 'bi-card-text', href: null },
  { label: 'stake settings', icon: 'bi-bullseye', href: '/profile/stake-settings' },
  { label: 'Unsettled Bets', icon: 'bi-bar-chart', href: '/reports/unsettled-bets' },
  { label: 'Change Password', icon: 'bi-lock', href: '/profile/change-password' },
];

export default function AccountMenu({ user }) {
  const navigate = useNavigate();
  const { logout } = useReddyAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const go = (href) => { setOpen(false); if (href) navigate(href); };
  const signOut = () => { setOpen(false); logout(); navigate('/'); };
  const stop = (e) => e.preventDefault();

  return (
    <>
      <li className="nav-item expo_bal">
        <a href="javascript:void(0);" className="nav-link" onClick={stop}>
          <i className="bi bi-bank" /><span>Bal<b>{user.bal}</b></span>
        </a>
      </li>
      <li className="nav-item expo_bal">
        <a href="javascript:void(0);" className="nav-link" onClick={stop}>
          <i className="bi bi-bar-chart" /><span>exp<b>{user.exp}</b></span>
        </a>
      </li>
      <li className="nav-item dropdown pe-3" ref={ref}>
        <a
          href="javascript:void(0);"
          className="nav-link nav-profile d-flex align-items-center pe-0"
          aria-expanded={open}
          onClick={(e) => { e.preventDefault(); setOpen((o) => !o); }}
        >
          <i className="bi bi-person-fill userpro-icons" />
          <span className="dropdown-toggle ps-lg-2">{user.id}</span>
        </a>
        <ul className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow profile${open ? ' show' : ''}`}>
          <li className="dropdown-header"><h6>HI, {user.id}</h6></li>
          <li className="balance-information">
            <div className="balance-row"><div className="balance-text-left">Wallet Amount <small>(Inclusive bonus)</small></div><div className="balance-price">{user.wallet}</div></div>
            <div className="balance-row"><div className="balance-text-left">Net Exposure</div><div className="balance-price">{user.netExposure}</div></div>
            <div className="balance-row"><div className="balance-text-left">Bonus</div><div className="balance-price">{user.bonus}</div></div>
            <div className="balance-row"><div className="balance-text-left">Available Withdrawal</div><div className="balance-price">{user.availableWithdrawal}</div></div>
          </li>
          <li className="ab_rae_btns">
            <button type="button" className="ab_btns">Awaiting Bonus <span>{user.awaitingBonus}</span></button>
            <button type="button" className="rae_btns">REFER AND EARN</button>
          </li>
          {MENU.map((m) => (
            <li key={m.label}>
              <a href="javascript:void(0);" className="dropdown-item d-flex align-items-center" onClick={(e) => { e.preventDefault(); go(m.href); }}>
                {m.img ? <IconImg src={`${EVT}/menu-home.png`} /> : <i className={`bi ${m.icon}`} />}
                <span>{m.label}</span>
              </a>
            </li>
          ))}
          <li>
            <a href="javascript:void(0);" className="dropdown-item d-flex align-items-center" onClick={(e) => { e.preventDefault(); signOut(); }}>
              <i className="bi bi-box-arrow-right" /><span>Sign Out</span>
            </a>
          </li>
        </ul>
      </li>
    </>
  );
}
